//#region src/util/os.ts
const getCurrentOs = () => {
	const userAgent = window?.navigator?.userAgent ?? "";
	if (/iPad|iPhone|iPod/.test(userAgent)) return "ios";
	if (/Android/.test(userAgent)) return "android";
	return "desktop";
};

//#endregion
export { getCurrentOs };